import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {PreferitiService} from "../../services/preferiti.service";
import {Router} from "@angular/router";
import {Preferiti, ResidenzaDomicilio} from "../../models/preferiti";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {format} from "date-fns";
import {AlertService} from "../../shared/alert/alert.service";
import {AbstractControl, FormArray, FormBuilder, FormControl, Validators} from "@angular/forms";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-gestione-preferiti',
  templateUrl: './gestione-preferiti.component.html',
  styleUrls: ['./gestione-preferiti.component.scss']
})
export class GestionePreferitiComponent extends SubscriptionManager implements OnInit {
  tables: string[] = [];
  preferiti!: Preferiti;
  loading = false;
  mapEstensioni: Map<string, string>;
  windowSize = window.innerWidth;
  fileUploaded = false;
  fileUpload = '';
  fileNameSelected = '';
  fileDescription = '';
  idFile!: number | null;
  formArrayFigli = this.fb.array([]);
  formArrayConviventi = this.fb.array([]);
  formArrayAllegati = this.fb.array([]);
  formArrayImmobili = this.fb.array([]);
  @ViewChild('_MD_VISURE') _md_visure!: ElementRef;
  coniugeForm = this.fb.group({
    id: [''],
    nome: [''],
    cognome: [''],
    codice_fiscale: [''],
    data_di_nascita: [''],
    luogo_di_nascita: [''],
    sesso: [''],
    tipo_entita: ['CON'],
  });
  residenzaForm = this.fb.group({
    id: [''],
    via: [''],
    numero_civico: [''],
    interno: [''],
    piano: [''],
    citta: [''],
    cap:[''],
    provincia: [''],
    nazione: [''],
    tipo_entita: ['RES'],
  });
  domicilioForm = this.fb.group({
    id: [''],
    via: [''],
    numero_civico: [''],
    interno: [''],
    piano: [''],
    citta: [''],
    cap:[''],
    provincia: [''],
    nazione: [''],
    tipo_entita: ['DOM'],
  });
  iseeForm = this.fb.group({
    id: [''],
    dtScadenza: [''],
    imValore: [this.fb.control<number | null>(null)],
    tipo_entita: [''],
  })
  coordinateBancarieForm = this.fb.group({
    id: [''],
    nomeIntestatario: [''],
    cognomeIntestatario: [''],
    iban: [''],
    swift: [''],
    tipo_entita: [''],
  });

  constructor(private preferitiService: PreferitiService, private route: Router, private alertService: AlertService, private fb: FormBuilder, private confService: ConfigurazioneGeneraleService) {
    super();
    this.mapEstensioni = new Map(
      [
        ["pdf", "application/pdf"],
        ["zip", "application/x-zip-compressed"],
        ["xls", "application/vnd.ms-excel"],
        ["jpg", "image/jpeg"],
        ["png", "image/png"],
        ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
        ["PDF", "application/pdf"],
        ["ZIP", "application/x-zip-compressed"],
        ["XLS", "application/vnd.ms-excel"],
        ["JPG", "image/jpeg"],
        ["PNG", "image/png"],
        ["DOCX", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
      ]
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.getSezioni();
    this.getPreset();
  }

  format(data: string): string {
    return format(new Date(data), 'dd/MM/yyyy');
  }

  getSezioni(): void {
    this.loading = true;
    this.subs.sink = this.preferitiService.getSezioni().subscribe({
      next: (res) => {
        this.tables = res;
        this.loading = false;
      },
      error: () => {
        void this.route.navigate(['error']);
        this.loading = false
      }
    });
  }

  getPreset(): void {
    this.loading = true;
    this.subs.sink = this.preferitiService.getPreset().subscribe({
      next: (res) => {
        this.getArrayFigli().clear();
        this.getArrayConviventi().clear();
        this.getArrayAllegati().clear();
        this.getArrayImmobili().clear();
        this.preferiti = res;
      },
      error: () => {
        void this.route.navigate(['error']);
        this.loading = false;
      },
      complete: () => {
        if (this.preferiti.figlio) {
          this.preferiti.figlio.forEach(figlio => {
            this.getArrayFigli().push(this.fb.group({
              id: figlio.id,
              nome: figlio.nome,
              cognome: figlio.cognome,
              codice_fiscale: figlio.codice_fiscale,
              data_di_nascita: figlio.data_di_nascita,
              luogo_di_nascita: figlio.luogo_di_nascita,
              sesso: figlio.sesso,
              tipo_entita: figlio.tipo_entita,
            }));
          });
          this.getArrayFigli().markAsPristine();
        }
        if (this.preferiti.figlio.length === 0) {
          this.addFiglio();
          this.getArrayFigli().markAsPristine();
        }
        if(this.preferiti.immobile){
          this.preferiti.immobile.forEach(imm => {
            this.getArrayImmobili().push(this.fb.group({
              id: imm.id,
              via: imm.via,
              numero_civico: imm.numero_civico,
              interno: imm.interno,
              piano: imm.piano,
              citta: imm.citta,
              provincia: imm.provincia,
              cap: imm.cap,
              nazione: imm.nazione,
              sezione: imm.sezione,
              foglio: imm.foglio,
              numero: imm.numero,
              subalterno: imm.subalterno,
              codice_ateco: imm.codice_ateco,
              uso: imm.uso,
              categoria: imm.categoria,
              tipo_entita: imm.tipo_entita
            }));
          });
          this.getArrayImmobili().markAsPristine();
        }
        if (this.preferiti.immobile.length === 0) {
          this.addImmobile();
          this.getArrayImmobili().markAsPristine();
        }
        if (this.preferiti.convivente) {
          this.preferiti.convivente.forEach(convivente => {
            this.getArrayConviventi().push(this.fb.group({
              id: convivente.id,
              nome: convivente.nome,
              cognome: convivente.cognome,
              codice_fiscale: convivente.codice_fiscale,
              data_di_nascita: convivente.data_di_nascita,
              luogo_di_nascita: convivente.luogo_di_nascita,
              sesso: convivente.sesso,
              tipo_entita: convivente.tipo_entita,
            }));
          });
          this.getArrayConviventi().markAsPristine();
        }
        if (this.preferiti.convivente.length === 0) {
          this.addConvivente();
          this.getArrayConviventi().markAsPristine();
        }

        if (this.preferiti.allegati) {
          this.preferiti.allegati.forEach(allegato => {
            this.getArrayAllegati().push(this.fb.group({
              id: allegato.id,
              titolo: allegato.titolo,
              descrizione: allegato.descrizione,
              contenuto: allegato.contenuto,
              tipo_entita: allegato.tipo_entita
            }));
          });
        }

        if (this.preferiti.residenza) {
          this.residenzaForm.patchValue({
            id: this.preferiti.residenza.id,
            via: this.preferiti.residenza.via,
            numero_civico: this.preferiti.residenza.numero_civico,
            interno: this.preferiti.residenza.interno,
            piano: this.preferiti.residenza.piano,
            citta: this.preferiti.residenza.citta,
            cap: this.preferiti.residenza.cap,
            provincia: this.preferiti.residenza.provincia,
            nazione: this.preferiti.residenza.nazione,
            tipo_entita: this.preferiti.residenza.tipo_entita,
          })
          this.residenzaForm.markAsPristine();
        }

        if (this.preferiti.domicilio) {
          this.domicilioForm.patchValue({
            id: this.preferiti.domicilio.id,
            via: this.preferiti.domicilio.via,
            numero_civico: this.preferiti.domicilio.numero_civico,
            interno: this.preferiti.domicilio.interno,
            piano: this.preferiti.domicilio.piano,
            citta: this.preferiti.domicilio.citta,
            cap: this.preferiti.domicilio.cap,
            provincia: this.preferiti.domicilio.provincia,
            nazione: this.preferiti.domicilio.nazione,
            tipo_entita: this.preferiti.domicilio.tipo_entita,
          })
          this.domicilioForm.markAsPristine();
        }

        if (this.preferiti.coordinate_bancarie) {
          this.coordinateBancarieForm.patchValue({
            id: this.preferiti.coordinate_bancarie.id,
            nomeIntestatario: this.preferiti.coordinate_bancarie.nomeIntestatario,
            cognomeIntestatario: this.preferiti.coordinate_bancarie.cognomeIntestatario,
            iban: this.preferiti.coordinate_bancarie.iban,
            swift: this.preferiti.coordinate_bancarie.swift,
            tipo_entita: this.preferiti.coordinate_bancarie.tipo_entita,
          })
          this.coordinateBancarieForm.markAsPristine();
        }

        if (this.preferiti.isee) {
          this.iseeForm.patchValue({
            id: this.preferiti.isee.id,
            imValore: this.preferiti.isee.imValore,
            dtScadenza: this.preferiti.isee.dtScadenza,
            tipo_entita: this.preferiti.isee.tipo_entita,
          })
          this.iseeForm.markAsPristine();
        }

        if (this.preferiti.coniuge) {
          this.coniugeForm.patchValue({
            id: this.preferiti.coniuge.id,
            nome: this.preferiti.coniuge.nome,
            cognome: this.preferiti.coniuge.cognome,
            codice_fiscale: this.preferiti.coniuge.codice_fiscale,
            data_di_nascita: this.preferiti.coniuge.data_di_nascita,
            luogo_di_nascita: this.preferiti.coniuge.luogo_di_nascita,
            sesso: this.preferiti.coniuge.sesso,
            tipo_entita: this.preferiti.coniuge.tipo_entita,
          })
          this.coniugeForm.markAsPristine();
        }

        this.loading = false;
      }
    });
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    return absCtrl as FormControl;
  }

  openMdPreferiti():void{
    this._md_visure.nativeElement.click();
  }

  aggiornaPrefDaVis():void{
    this.openMdPreferiti();
    this.loading = true;
    this.preferitiService.updatePreferiti().subscribe({
      next: () =>{
        this.loading = false;
          this.alertService.creaAlert("Dati aggiornati correttamente", "success", "sticky", 4000, true);
          this.loading = true;
          this.getPreset();

    },
      error: (err) =>{
        this.loading = false;
        if(err.error.messaggio){
          this.alertService.creaAlert(err.error.messaggio, "warning", "sticky", 4000, true);
        }
    }
    })
  }

  getArrayFigli(): FormArray {
    return this.formArrayFigli;
  }

  getArrayImmobili(): FormArray{
    return this.formArrayImmobili;
  }

  addFiglio(): void {
    this.getArrayFigli().push(this.fb.group({
      id: [null],
      nome: [null],
      cognome: [null],
      codice_fiscale: [null],
      data_di_nascita: [null],
      luogo_di_nascita: [null],
      sesso: [null],
      tipo_entita: ['FIG']
    }));
  }

  removeFiglio(index: number): void {
    this.getArrayFigli().removeAt(index);
  }

  addImmobile(): void {
    this.getArrayImmobili().push(this.fb.group({
      id: [null],
      via: [null],
      numero_civico: [null],
      interno: [null],
      piano: [null],
      citta: [null],
      provincia: [null],
      cap: [null],
      nazione: [null],
      sezione: [null],
      foglio: [null],
      numero: [null],
      subalterno: [null],
      codice_ateco: [null],
      uso: [null],
      categoria: [null],
      tipo_entita: ['IMM']
    }));
  }

  removeImmobile(index: number): void{
    this.getArrayImmobili().removeAt(index);
  }

  deleteFiglio(id: string, index: number): void {
    if(id !== null) {
      this.loading = true;
      this.preferitiService.deletePersona(id).subscribe({
        next: (res) => {
          this.getArrayFigli().removeAt(index);
          this.getArrayFigli().markAsPristine();
          if(this.getArrayFigli().length === 0){
            this.addFiglio();
          }
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true)
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        },
      });
    }
  }

  deleteImmobile(id: string, index: number): void {
    if(id !== null) {
      this.loading = true;
      this.preferitiService.deleteImmobile(id).subscribe({
        next: (res) => {
          this.getArrayImmobili().removeAt(index);
          this.getArrayImmobili().markAsPristine();
          if(this.getArrayImmobili().length === 0){
            this.addImmobile();
          }
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true)
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        },
      });
    }
  }

  deleteConiuge(id: string | undefined | null): void{
    if(<string>id !== null) {
      this.loading = true;
      this.preferitiService.deletePersona(<string>id).subscribe({
        error: (err) => {
          this.loading = false;
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        },
        complete: () => {
          this.coniugeForm.reset();
          this.loading = false;
        }
      });
    }
  }

  getArrayAllegati(): FormArray {
    return this.formArrayAllegati;
  }


  getArrayConviventi(): FormArray {
    return this.formArrayConviventi;
  }

  addConvivente(): void {
    this.getArrayConviventi().push(this.fb.group({
      id: [null],
      nome: [null],
      cognome: [null],
      codice_fiscale: [null],
      data_di_nascita: [null],
      luogo_di_nascita: [null],
      sesso: [null],
      tipo_entita: ['COV']
    }));
  }

  removeConvivente(index: number): void {
    this.getArrayConviventi().removeAt(index);
  }

  deleteConvivente(id: string, index: number): void {
    if(id !== null) {
      this.loading = true;
      this.preferitiService.deletePersona(id).subscribe({
        error: (err) => {
          this.loading = false;
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        },
        complete: () => {
          this.getArrayConviventi().removeAt(index);
          this.getArrayConviventi().markAsPristine();
          if (this.getArrayConviventi().length === 0) {
            this.addConvivente();
          }
          this.loading = false;
        }
      });
    }
  }

  modificaPersona(persona: string): void {
    if (persona === 'convivente') {
      this.loading = true
      this.preferitiService.modificaPersona(this.getArrayConviventi().value).subscribe({
        next: (res) => {
          this.getPreset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      });
    } else if (persona === 'figlio') {
      this.loading = true
      this.preferitiService.modificaPersona(this.getArrayFigli().value).subscribe({
        next: (res) => {
          this.getPreset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      });
    }
  }

  modificaImmobili(): void{
    this.loading = true;
    this.preferitiService.modificaImmobile(this.getArrayImmobili().value).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
      }
    })
  }

  modificaConiuge(): void {
    this.loading = true;
    const coniugeValue = {
      id: this.coniugeForm.value.id ?? '',
      nome: this.coniugeForm.value.nome ?? '',
      cognome: this.coniugeForm.value.cognome ?? '',
      codice_fiscale: this.coniugeForm.value.codice_fiscale ?? '',
      data_di_nascita: this.coniugeForm.value.data_di_nascita ?? '',
      luogo_di_nascita: this.coniugeForm.value.luogo_di_nascita ?? '',
      sesso: this.coniugeForm.value.sesso ?? '',
      tipo_entita: this.coniugeForm.value.tipo_entita ?? ''
    };
    this.preferitiService.modificaConiuge(coniugeValue).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
    })
  }

  modificaIndirizzo(domicilioResidenza: string): void {
    this.loading = true;
    if (domicilioResidenza === 'residenza') {
      const residenzaValue = {
        id: this.residenzaForm.value.id ?? '',
        via: this.residenzaForm.value.via ?? '',
        numero_civico: this.residenzaForm.value.numero_civico ?? '',
        interno: this.residenzaForm.value.interno ?? '',
        piano: this.residenzaForm.value.piano ?? '',
        citta: this.residenzaForm.value.citta ?? '',
        cap: this.residenzaForm.value.cap ?? '',
        provincia: this.residenzaForm.value.provincia ?? '',
        nazione: this.residenzaForm.value.nazione ?? '',
        tipo_entita: this.residenzaForm.value.tipo_entita ?? ''
      };
      this.preferitiService.modificaIndirizzo(residenzaValue).subscribe({
        next: (res) => {
          this.getPreset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      })
    } else if (domicilioResidenza === 'domicilio') {
      const domicilioValue: ResidenzaDomicilio = {
        id: this.domicilioForm.value.id ?? '',
        via: this.domicilioForm.value.via ?? '',
        numero_civico: this.domicilioForm.value.numero_civico ?? '',
        interno: this.domicilioForm.value.interno ?? '',
        piano: this.domicilioForm.value.piano ?? '',
        citta: this.domicilioForm.value.citta ?? '',
        cap: this.domicilioForm.value.cap ?? '',
        provincia: this.domicilioForm.value.provincia ?? '',
        nazione: this.domicilioForm.value.nazione ?? '',
        tipo_entita: this.domicilioForm.value.tipo_entita ?? ''
      };
      this.preferitiService.modificaIndirizzo(domicilioValue).subscribe({
        next: (res) => {
          this.getPreset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      })
    }
  }

  modificaISEE(): void {
    this.loading = true;
    const iseeValue = {
      id: this.iseeForm.value.id ?? '',
      dtScadenza: this.iseeForm.value.dtScadenza ?? '',
      imValore: this.iseeForm.value.imValore ?? null,
      tipo_entita: this.iseeForm.value.tipo_entita ?? ''
    };
    this.preferitiService.modificaISEE(iseeValue).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
    })
  }

  modificaCoordinateBancarie(): void{
    this.loading = true;
    const coordinateBancarieValue = {
      id: this.coordinateBancarieForm.value.id ?? '',
      nomeIntestatario: this.coordinateBancarieForm.value.nomeIntestatario ?? '',
      cognomeIntestatario: this.coordinateBancarieForm.value.cognomeIntestatario ?? '',
      iban: this.coordinateBancarieForm.value.iban ?? '',
      swift: this.coordinateBancarieForm.value.swift ?? '',
      tipo_entita: this.coordinateBancarieForm.value.tipo_entita ?? ''
    };
    this.preferitiService.modificaCoordinateBancarie(coordinateBancarieValue).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
    })
  }

  importUpdateAllegato(): void{
    this.loading = true;
    const allegato = {
      id: this.idFile,
      titolo: this.fileNameSelected,
      contenuto: this.fileUpload,
      descrizione: this.fileDescription,
    }
    this.preferitiService.modificaAllegati(allegato).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
    })
  }
  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

  deleteAllegato(id: string): void{
    this.loading = true;
    this.preferitiService.deleteAllegato(id).subscribe({
      next: (res) => {
        this.getPreset();
        this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
        this.loading = false;
      },
      error: (err) => {
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
        this.loading = false;
      },
    });
  }

  deleteCoordinate(id: string | null | undefined): void{
    if(id) {
      this.loading = true;
      this.preferitiService.deleteCoordinate(<string>id).subscribe({
        next: (res) => {
          this.coordinateBancarieForm.reset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      })
    }
  }

  deleteISEE(id: string | null | undefined): void{
    if(id) {
      this.loading = true;
      this.preferitiService.deleteISEE(<string>id).subscribe({
        next: (res) => {
          this.iseeForm.reset();
          this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
          this.loading = false;
        },
        error: (err) => {
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
          this.loading = false;
        },
      })
    }
  }

  deleteIndirizzo(id: string | null | undefined, residenzaDomicilio: string): void{
    if(id) {
      this.loading = true;
      if (residenzaDomicilio === 'residenza') {
        this.preferitiService.deleteIndirizzo(<string>id).subscribe({
          next: (res) => {
            this.residenzaForm.reset();
            this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
            this.loading = false;
          },
          error: (err) => {
            this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
            this.loading = false;
          },
        })
      }else if(residenzaDomicilio === 'domicilio'){
        this.preferitiService.deleteIndirizzo(<string>id).subscribe({
          next: (res) => {
            this.domicilioForm.reset();
            this.alertService.creaAlert(res.messaggio, "success", "sticky", 5000, true);
            this.loading = false;
          },
          error: (err) => {
            this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
            this.loading = false;
          },
        })
      }
    }
  }

  downloadAllegato(base64String: string | null, fileName: string): void {
    const split = fileName.split('.');
    const fileExtension = split[split.length - 1];
    const fileExtensionMapped = this.mapEstensioni.get(fileExtension)
    const source = 'data:' + fileExtensionMapped + `;base64,${<string>base64String}`;
    const link = document.createElement('a');
    link.href = source;
    link.download = `${fileName}`;
    link.click();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'copy';
    this.addDragOverClass();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverClass();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverClass();
    const files = event.dataTransfer!.files;
    if (files.length > 0) {
      const file = files[0];
      this.fileNameSelected = file.name;
      this.fileUploaded = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        this.fileUpload = '';
        setTimeout(() => {
          this.fileUpload = base64String.split(',')[1];
        }, 0);
      };
      reader.readAsDataURL(file);
    }
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const files = inputElement.files;
    if (files && files.length > 0) {
      const file = files[0];
      this.fileNameSelected = file.name;
      this.fileUploaded = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result as string;
        // Rimuovi l'intestazione "data:image/png;base64,"
        this.fileUpload = base64Data.split(',')[1];
      };
      reader.readAsDataURL(file);
    }
  }

  removeFile(): void {
    this.fileNameSelected = '';
    this.fileUploaded = false;
    this.fileUpload = '';
    this.fileDescription = '';
    this.idFile = null;
  }

  updateFile(id: number, nome: string, contenuto: string, descrizione: string): void{
    this.fileNameSelected = nome;
    this.fileUploaded = true;
    this.fileUpload = contenuto;
    this.fileDescription = descrizione;
    this.idFile = id;
  }

  changeFile(): void {
    const newFileInput = document.createElement('input');
    newFileInput.type = 'file';
    newFileInput.style.display = 'none';
    newFileInput.addEventListener('change', event => this.onFileSelected(event));
    const existingFileInput = document.getElementById('fileInput');
    if (existingFileInput?.parentNode) {
      existingFileInput.parentNode.replaceChild(newFileInput, existingFileInput);
      newFileInput.click();
    }
  }

  openFileInput(): void {
    const fileInput = document.getElementById('fileInput');
    if (fileInput) {
      fileInput.click();
    }
  }

  private addDragOverClass(): void {
    const dropzone = document.getElementById('myDropzone');
    dropzone?.classList.add('drag-over');
  }

  private removeDragOverClass(): void {
    const dropzone = document.getElementById('myDropzone');
    dropzone?.classList.remove('drag-over');
  }
}
